import axios from "@helpers/axios/private.axios";

export const uploadKycDocument = (type, file) => async () => {
  const formData = new FormData();

  formData.append("type", type);
  formData.append("file", file);

  const response = await axios.post("/kyc/documents", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const submitKycVerification = () => async () => {
  const response = await axios.post(
    "/kyc/submit",
    {},
    {
      headers: {
        Accept: "application/json",
      },
    },
  );

  return response.data;
};